/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../common/controller/signal-admin-resource-api';

export interface FolioModel extends SignalAdminResourceModel {
  [key: string]: any;
}

export interface FolioCopyOptions {
  name: string;
  copyLineItems?: boolean;
  copyTargeting?: boolean;
  copyCreatives?: boolean;
  creativeSetUserState?: string;
}

@Injectable({providedIn: 'root'})
export class FolioApiService extends SignalAdminResourceApiBase<FolioModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'folios');
  }

  listOptions(params: Record<string, any> = {}): Observable<SignalAdminResourcePage<FolioModel>> {
    return this.client.request<SignalAdminResourcePage<FolioModel>>({
      method: 'GET',
      url: this.resourceUri('folios'),
      params
    });
  }

  copy(sourceId: string, newId: string, options: FolioCopyOptions): Observable<void> {
    return this.client.request<void>({
      method: 'POST',
      url: this.resourceUri(['folios', sourceId, 'copy']),
      params: {
        folioId: newId || '',
        name: options.name,
        copyLineItems: options.copyLineItems ?? true,
        copyTargeting: options.copyTargeting ?? true,
        copyCreatives: options.copyCreatives ?? true,
        creativeSetUserState: options.creativeSetUserState || ''
      }
    });
  }

  refresh(id: string): Observable<FolioModel> {
    return this.client.request<FolioModel>({
      method: 'POST',
      url: this.resourceUri(['folios', id]),
      body: {id}
    });
  }
}
